import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/helper/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { ErrorToast, SuccessToast } from "@/components/toast/Toasts";
import { ISetting, ISettingDetails } from "./settingModel";

export const findAllSetting = createAsyncThunk("Setting/FindAllSetting", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_PORTAL_URL}/Setting/FindAllSetting`,
      {
        SettingKey: "",
      },
    );
    return response.data?.Data.map((item: any) => ({
      ...item,
      IsActive: item.IsActive || false,
    }));
  } catch (error: any) {
    console.error("Error Fetching Setting:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const insertSetting = createAsyncThunk(
  "Setting/InsertSetting",
  async (settingData: ISettingDetails) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Setting/InsertSetting`,
        settingData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateSetting = createAsyncThunk(
  "Setting/UpdateSetting",
  async (settingData: ISettingDetails) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Setting/UpdateSetting`,
        settingData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findByIDSetting = createAsyncThunk(
  "Setting/FindByIDSetting",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Setting/FindByIDSetting`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        SettingKey: result.SettingKey,
        SettingType: result.SettingType || "",
        SettingValue: result.SettingValue || "",
        IsActive: result.IsActive || false,
      } as ISetting;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactiveSetting = createAsyncThunk(
  "Setting/ActiveInActiveSetting",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Setting/ActiveInActiveSetting`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteSetting = createAsyncThunk(
  "Setting/DeleteSetting",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Setting/DeleteSetting`,
        {
          ID,
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
